<template>
  <div>
    <div class="section-center-content-box bonushHeight">
      <div class="backCardList" @click="goNumList">
        <i class="el-icon-arrow-left"></i> 
        <span class="verticalLine">|</span>
        <span class="membership">积分奖励规则</span>
      </div>
      <div>
        <span>当一个订单符合多个规则时：</span>&nbsp;&nbsp;&nbsp;
        <el-radio-group
          class="groupclass"
          v-model="maxValue"
          @change="handleRadioChange"
        >
          <el-radio :label="1">取最大分值</el-radio>
          <el-radio :label="2">叠加分值奖励</el-radio>
        </el-radio-group>
      </div>
      <!-- </div>
    <div class="section-center-content-box rulesGame"> -->
      <div>
        <el-button class="addbutton" @click="addReward">
          <i class="iconfont icontianjia" style="font-size: 12px"></i>
          添加奖励规则</el-button
        >
      </div>
      <!-- 表格 -->
      <div class="table-box">
        <el-table
          v-loading="tableLoading"
          ref="multipleTable"
          :data="lists"
          class="table-fixed"
          tooltip-effect="dark"
               :cell-style="{'text-align':'left'}"
          :header-cell-style="{ background: '#F4F4F4', height: '42px' }"
        >
        <template slot="empty">
              <div style="margin: 20px;">
                <img src="../../../assets/images/nodata.png"
                      style="display: inline-block; vertical-align: middle; cursor: pointer;">
                <span style="color:#999999" class="nodata">没有数据哦~</span>
                <!-- <span class="nodata1">暂无数据</span> -->
              </div>
            </template>
          <el-table-column label="序号" prop="rewardRule"></el-table-column>
          <el-table-column label="规则名称" prop="ruleName"> </el-table-column>
          <el-table-column label="奖励规则">
            <template slot-scope="scope">
              <span v-if="scope.row.rewardRule == '1'">固定积分奖励</span>
              <span v-else>倍数积分奖励</span>
            </template>
          </el-table-column>
          <el-table-column label="下单奖励时间" min-width="180">
            <template slot-scope="scope">
              <span>{{ scope.row.firstPayTime }}</span>
              <br />
              <span>{{ scope.row.lastPayTime }}</span>
            </template>
          </el-table-column>
          <el-table-column label="累计发放积分" prop="scoresSum">
          </el-table-column>
          <el-table-column label="近7天发放积分" prop="scoresSumInWeek">
          </el-table-column>
          <el-table-column label="添加人" prop="createPerson">
          </el-table-column>
          <el-table-column label="添加时间" prop="createTime" min-width="180">
          </el-table-column>
          <el-table-column label="操作" width="200px" fixed="right">
            <template slot-scope="scope">
              <span>
                <el-switch
                  v-model="scope.row.ruleStatus"
                  :active-value="1"
                  :inactive-value="0"
                  @change="
                    openAllD(scope.row.ruleStatus, scope.row.scoresRewardRuleId)
                  "
                >
                </el-switch>
              </span>
              <span>
                <span
                  class="editElembutton"
                  @click="editElem(scope.row.scoresRewardRuleId)"
                  >编辑</span
                >
              </span>
              <span>
                <span
                  class="deleteElembutton"
                  v-if="scope.row.ruleStatus != 1"
                  @click="deleteElem(scope.row.scoresRewardRuleId)"
                  >删除</span
                >
                <span
                  class="deleteElembutton"
                  style="color:#cccccc"
                  v-if="scope.row.ruleStatus == 1"
                  >删除</span
                >
              </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
          :current-page="pageNum"
          style="text-align: right; margin-top: 31px"
        ></el-pagination>
      </div>
    </div>
    <!-- 添加奖励规则弹窗 -->
    <el-dialog
      :title="messageAddEcit"
      :visible.sync="dialogVisible"
      width="800px"
      :before-close="handleClose"
    >
      <div class="addDialog">
        <div>
          <div class="label">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;规则名称：</div>
          <div class="formcnt">
            <el-input
              v-model="addRuleParm.ruleName"
              style="width: 300px"
              :placeholder="'输入规则名称'"
            ></el-input>
          </div>
        </div>
        <div>
          <div class="label">指定交易渠道：</div>
          <!-- <div class="formcnt"> -->
            <el-button class="formcntButton" size="small" @click="addShop"
              >添加</el-button
            >
            <div class="form-item" style="height: auto">
              <div style="margin-top: 10px;width: 600px;
    margin-left: 98px;">
                <el-table
             ref="multipleTable"
             :data="addRuleParm.includeShops"
              v-if="addRuleParm.includeShops.length > 0"
            class="table-fixed"
             tooltip-effect="dark"
           :header-cell-style="{background:'#F4F4F4',height:'42px'}"
             style="width: 100%; border: 1px solid #EFEFEF;"
          >
              <template slot="empty">
                  <div style="margin: 20px;">
                    <img src="../../../assets/images/nodata.png"
                          style="display: inline-block; vertical-align: middle; cursor: pointer;">
                    <span style="color:#999999" class="nodata">没有数据哦~</span>
                    <!-- <span class="nodata1">暂无数据</span> -->
                  </div>
                </template>
                  <el-table-column
                    prop="sellerNick"
                    label="店铺"
                    width="200px"
                  ></el-table-column>
                  <el-table-column label="商品" width="318px">
                    <template slot-scope="scope">
                      <div>
                        <el-radio
                          @change="updateTable"
                          :label="0"
                          v-model="addRuleParm.includeShops[scope.$index].type"
                          >全部</el-radio
                        >
                        <el-radio
                          @change="updateTable"
                          :label="1"
                          v-model="addRuleParm.includeShops[scope.$index].type"
                          >指定商品</el-radio
                        >
                        <el-button
                          @click="goodsDialog(scope.row)"
                          v-if="
                            addRuleParm.includeShops[scope.$index].type === 1 &&
                            scope.row.scoresRewardIncludeItems.length === 0"
                          >选择商品</el-button
                        >
                        <el-button
                          @click="goodsDialog(scope.row)"
                          v-else-if="
                            addRuleParm.includeShops[scope.$index].type === 1 &&
                            scope.row.scoresRewardIncludeItems.length > 0
                          "
                          >已选择({{
                            scope.row.scoresRewardIncludeItems.length
                          }})个</el-button
                        >
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="80px">
                    <template slot-scope="scope">
                      <span class="deleteGoodsbutton" @click="deleteGoods(scope.row)"
                        >删除</span
                      >
                    </template>
                  </el-table-column>
                </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        <!-- </div> -->
        <div>
          <div class="label">下单奖励时间：</div>
          <div class="my_select_time">
            <el-date-picker
              prefix-icon="no_icon"
              :type="'datetime'"
              :value-format="'yyyy-MM-dd HH:mm:ss'"
              :placeholder="'开始日期'"
              style="width: 136px; font-size: 12px !important"
              class="time1"
              size="small"
              :picker-options="pickerOptionsStart()"
              v-model="addRuleParm.firstPayTime"
              :clearable="false"
              :default-time="'00:00:00'"
            >
            </el-date-picker>
            <div class="time_to_text" style="color: #666666">~</div>
            <el-date-picker
              prefix-icon="no_icon"
              :type="'datetime'"
              :value-format="'yyyy-MM-dd HH:mm:ss'"
              style="width: 150px; font-size: 12px !important"
              class="time2"
              :placeholder="'结束日期'"
              size="small"
              :picker-options="pickerOptionsEnd()"
              v-model="addRuleParm.lastPayTime"
              :clearable="false"
              :default-time="'23:59:59'"
            >
            </el-date-picker>
            <i class="el-icon-circle-close date_icon1" @click="clearTime()"></i>
            <img
              src="@/assets/images/select_date.svg"
              alt=""
              class="date_icon2"
            />
          </div>
        </div>
        <div style="padding-left: 100px">
          <el-alert
            title
            style="width: 90%"
            type="warning"
            :closable="false"
            class="global-comment tips_title2"
            show-icon
          >
            <template slot="title">
              <div class="tip-alert">
                <div
                  class="tip-content"
                  style="font-size: 13px; margin-top: -3px; color: #333333"
                >
                  <p>1. 选择历史时间，将会把历史订单重新赠送一次积分</p>
                  <p>
                    2.
                    奖励的时间按照付款时间计算，但结算时按照确认收货的时间结算
                  </p>
                </div>
              </div>
            </template>
          </el-alert>
        </div>
        <div>
          <div class="label" style="vertical-align: top;">订单奖励比例：</div>
          <el-radio-group
            v-model="addRuleParm.rewardRule"
            @change="handleRadioChange1"
          >
            <div style="line-height: 40px;margin-top:-5px;">
              <el-radio style="margin-right: 8px" :label="1"
                >固定积分奖励</el-radio
              >
              <el-input
                v-model="addRuleParm.scoresFix"
                style="width: 146px"
                type="number"
                class="changeinput"
                onkeypress="return (event.keyCode>=48 && event.keyCode<=57)||event.keyCode==46"
              ></el-input>
              <span
                style="
                  font-size: 14px;
                  position: relative;
                  top: 0px;
                  left: -38px;
                "
              >
                积分</span
              >
            </div>
            <div>
              <el-radio style="margin-right: 8px" :label="2"
                >倍数积分奖励</el-radio
              >
              <el-input
                v-model="addRuleParm.scoresMultiple"
                style="width: 146px"
                type="number"
                class="changeinput"
                onkeypress="return (event.keyCode>=48 && event.keyCode<=57)||event.keyCode==46"
              ></el-input>
              <span
                style="
                  font-size: 14px;
                  position: relative;
                  top: 0px;
                  left: -48px;
                "
                >倍积分</span
              >
            </div>
          </el-radio-group>
        </div>
      </div>
      <div style="text-align: right" class="bottom">
        <el-button class="bottombutton1" @click="dialogVisible = false"
          >取消</el-button
        >
        <el-button class="bottombutton2" @click="saveCreate">保存</el-button>
      </div>
    </el-dialog>
    <!--选择店铺-->
    <el-dialog
      title="选择店铺"
      :visible.sync="addDialogVisible"
      width="600px"
      :before-close="handleCloseAdd"
    >
      <div>
        <span
          v-for="(item, index) in shopInfo"
          :key="index"
          class="shopItem"
          :class="{
            active:selectshop.map((i) => i.sellerNick).indexOf(item.sellerNick) !=-1,
          }"
          @click="selShop(item)"
          >

          {{ item.sellerNick }}</span
        >
      </div>
      <div class="bottom" style="text-align: right">
        <el-button class="bottombutton1" @click="preserve1">取消</el-button>
        <el-button class="bottombutton2" @click="preserve1">保存</el-button>
      </div>
    </el-dialog>
    <!-- 选择商品组件 -->
    <selectGoodsCard
      v-if="goodsState"
      @transferName="dataBtn"
      :goodsArr="goodsCollection"
      :shopItem="selectCol"
    >
    </selectGoodsCard>
  </div>
</template>
<script>
import {
  rewDetail,
  rewList,
  insert,
  rewDelete,
  rewUpdate,
  updateStatus,
  getRewardType,
  updateRewardType,
  pageList,
} from "@/api/manage/scoreList";
import selectGoodsCard from "@/components/select-goods-card";
export default {
  name: "bonus_points",
  props: {
    bonusId: null,
  },
  components: {
    selectGoodsCard,
  },
  data() {
    return {
      rewardRuled: "", //奖励规则的id
      messageAddEcit: "",
      addDialogVisible: false,
      showtable: true,
      selectCol: null,
      goodsCollection: [], //商品选择参数
      goodsState: false,
      maxValue: 1,
      dialogVisible: false,
      dialogVisible1: false, //选择店铺弹窗
      lists: [],
      shopInfo: [], //获取所有店铺会员
      selectshop: [],
      addRuleParm: {
        ruleName: "", //规则名称
        firstPayTime: "", //下单奖励时间开始
        lastPayTime: "",
        rewardRule: 1,
        scoresFix: "",
        scoresMultiple: "",
        includeShops: [],
      },
      pageSize: 10,
      pageNum: 1,
      totalCount: 0,
      tableLoading: true,
    };
  },
  mounted() {
    this.queryList();
    this.getRewardType();
  },
  methods: {
    //分页事件
    handleSizeChange(val) {
      this.pageSize = val;
      this.searchFileList();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.searchFileList();
    },
    updateTable() {
      this.showtable = false;
      this.$nextTick(() => {
        this.showtable = true;
      });
    },
    pickerOptionsStart() {
      return {
        disabledDate: (time) => {
          if (this.addRuleParm.lastPayTime) {
            var flag = false;
            flag =
              time.getTime() > new Date(this.addRuleParm.lastPayTime).getTime();
            return flag;
          }
        },
      };
    },
    pickerOptionsEnd() {
      return {
        disabledDate: (time) => {
          if (this.addRuleParm.firstPayTime) {
            var flag = false;
            return (
              time.getTime() < new Date(this.addRuleParm.firstPayTime).getTime()
            );
          }
        },
      };
    },
    clearTime() {
      this.addRuleParm.lastPayTime = "";
      this.addRuleParm.firstPayTime = "";
    },
    //选择商品数量
    goodsDialog(row) {
      this.selectCol = row;
      row.scoresRewardIncludeItems.forEach((item) => {
        item.state = true;
      });
      this.goodsCollection = row.scoresRewardIncludeItems;
      console.log(row.scoresRewardIncludeItems);
      this.goodsState = true;
    },
    //添加规则奖励弹窗
    handleClose() {
      this.selectshop = JSON.parse(
        JSON.stringify(this.addRuleParm.includeShops)
      );
      this.dialogVisible = false;
    },
    //添加弹窗关闭
    handleCloseAdd() {
      this.addDialogVisible = false;
    },
    selShop(item) {
      let ind = this.selectshop
        .map((i) => i.sellerNick)
        .indexOf(item.sellerNick);
      if (ind === -1) {
        this.selectshop.push(item);
      } else {
        this.selectshop.splice(ind, 1);
      }
    },
    //查询订单符合规则
    getRewardType() {
      getRewardType({ cardId: this.bonusId })
        .then((res) => {
          this.maxValue = res.data.rewardType;
        })
        .catch(() => {});
    },
    //修改奖励规则计算方式
    handleRadioChange(val) {
      let reward = {
        cardId: this.bonusId,
        rewardType: val,
      };
      this.tableLoading = true;
      updateRewardType(reward).then(() => {});
      rewList(reward)
        .then((res) => {
          if (res.code == 200) {
            this.lists = res.data;
          }
          this.tableLoading = false;
        })
        .catch(() => {});
    },
    //获取积分奖励规则列表
    queryList() {
      this.tableLoading = true;
      rewList({ cardId: this.bonusId })
        .then((res) => {
          if (res.code == 200) {
            this.lists = res.data;
            this.tableLoading = false;
          }
        })
        .catch(() => {});
    },
    //删除数据
    deleteElem(type) {
      rewDelete({ ruleId: type })
        .then((res) => {
          if (res.code == 200) {
            this.$message.success("删除成功");
            this.queryList();
          }
        })
        .catch((err) => {});
    },
    //开关
    openAllD(id, type) {
      let upStatus = {
        ruleId: type,
        status: id,
      };
      updateStatus(upStatus)
        .then((res) => {
          if (res.code == 200) {
            this.$message.success(res.message);
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(() => {});
    },
    //添加奖励规则
    addReward() {
      this.messageAddEcit = "添加奖励规则";
      this.dialogVisible = true;
      this.addRuleParm = {
        ruleName: "", //规则名称
        firstPayTime: "", //下单奖励时间开始
        lastPayTime: "",
        rewardRule: 1,
        scoresFix: "",
        scoresMultiple: "",
        includeShops: [],
      };
    },
    //奖励积分选择
    handleRadioChange1(val) {
      this.addRuleParm.rewardRule = val;
    },
    //商品添加
    addShop() {
      pageList({ cardId: this.bonusId })
        .then((res) => {
          this.shopInfo = res.data;
          this.shopInfo.forEach((item, index) => {
            this.shopInfo[index]["type"] = 0;
            this.shopInfo[index]["appointGoodsType"] = "";
            this.shopInfo[index]["scoresRewardIncludeItems"] = [];
          });
        })
        .catch(() => {});
      this.addDialogVisible = true;
      this.selectshop = [...this.addRuleParm.includeShops];
    },
    //添加弹窗保存
    saveCreate() {
      let obj = { ...this.addRuleParm };
      if (this.addRuleParm.ruleName === "") {
        this.$message.warning("请输入规则名称");
        return;
      } else if (
        !this.addRuleParm.firstPayTime ||
        !this.addRuleParm.lastPayTime
      ) {
        this.$message.warning("请输入完整时间");
        return;
      } else if (
        this.addRuleParm.firstPayTime &&
        this.addRuleParm.lastPayTime &&
        new Date(this.addRuleParm.firstPayTime).getTime() >
          new Date(this.addRuleParm.lastPayTime).getTime()
      ) {
        this.$message.warning("结束时间要大于开始时间");
        return;
      } else if (
        this.addRuleParm.rewardRule == 1 &&
        this.addRuleParm.scoresFix === ""
      ) {
        this.$message.warning("请输入固定积分奖励");
        return;
      } else if (
        this.addRuleParm.rewardRule == 2 &&
        this.addRuleParm.scoresMultiple === ""
      ) {
        this.$message.warning("请输入倍数积分奖励");
        return;
      }
      if (obj.includeShops.length > 0) {
        let showSelectTip = false;
        obj.includeShops.forEach((item) => {
          if (item.type == 1 && item.scoresRewardIncludeItems.length == 0) {
            showSelectTip = true;
          }
        });
        if (showSelectTip) {
          this.$message.warning("请选择指定商品");
          return;
        }
      }
      this.addRuleParm.scoresCardId = this.bonusId;
      if (this.messageAddEcit == "编辑奖励规则") {
        this.addRuleParm.scoresRewardRuleId = this.rewardRuled;
        rewUpdate(this.addRuleParm)
          .then((res) => {
            if (res.code == 200) {
              this.queryList();
            }
          })
          .catch(() => {});
      } else {
        insert(this.addRuleParm)
          .then((res) => {
            if (res.code == 200) {
              this.queryList();
            }
          })
          .catch(() => {});
      }
      this.dialogVisible = false;
    },
    //编辑
    editElem(type) {
      this.rewardRuled = type;
      this.messageAddEcit = "编辑奖励规则";
      this.dialogVisible = true;
      rewDetail({ ruleId: type })
        .then((res) => {
          if (res.code == 200) {
            let obj = { ...res.data };
            delete obj.createTime;
            delete obj.scoresSum;
            delete obj.scoresSumInWeek;
            delete obj.scoresRewardRuleId;
            delete obj.ruleStatus;
            delete obj.createPerson;
            this.addRuleParm = obj;
          }
        })
        .catch(() => {});
    },
    //删除
    deleteGoods(row) {
      let ind = this.selectshop
        .map((i) => i.sellerNick)
        .indexOf(row.sellerNick);
      this.selectshop.splice(ind, 1);
      this.addRuleParm.includeShops = JSON.parse(
        JSON.stringify(this.selectshop)
      );
    },
    dataBtn(data, type) {
      if (type === false) {
        this.goodsState = false;
      } else {
        this.addRuleParm.includeShops[
          this.addRuleParm.includeShops
            .map((i) => i.sellerNick)
            .indexOf(type.sellerNick)
        ].scoresRewardIncludeItems = [...data];
        this.addRuleParm.includeShops[
          this.addRuleParm.includeShops
            .map((i) => i.sellerNick)
            .indexOf(type.sellerNick)
        ].appointGoodsType = type.searchType;
        this.goodsState = false;
      }
    },
    //返回会员列表
    goNumList() {
      this.$emit("transformAnalysis");
    },
    //选择店铺保存
    preserve1() {
      this.addRuleParm.includeShops = JSON.parse(
        JSON.stringify(this.selectshop)
      );
      this.addDialogVisible = false;
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .changeinput .el-input__inner {
  padding-left: 8px;
  padding-right: 50px;
}
/deep/.el-radio__inner {
  border: 3px solid #dcdfe6;
  border-radius: 100%;
  width: 16px;
  height: 16px;
  background-color: #ffffff;
  position: relative;
  cursor: pointer;
  display: inline-block;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
/deep/.el-radio__inner::after {
  width: 8px;
  height: 8px;
  border-radius: 100%;
  background-color: #ffffff;
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%) scale(0);
  transform: translate(-50%, -50%) scale(0);
  -webkit-transition: -webkit-transform 0.15s ease-in;
  transition: -webkit-transform 0.15s ease-in;
  transition: transform 0.15s ease-in;
  transition: transform 0.15s ease-in, -webkit-transform 0.15s ease-in;
}
.rulesGame {
  .addDialog .formcnt {
    vertical-align: top;
  }
}
</style>
<style lang="scss" scoped>
.shopItem {
  border: 1px solid #b2b2b2;
  padding: 4px 16px;
  border-radius: 8px;
  cursor: pointer;
  & {
    margin-right: 15px;
    margin-bottom: 12px;
    display: inline-block;
  }
  &.active {
    border: 1px solid #2062e7;
    background-image: url("../../../assets/images/backstage/蒙版组 66.png");
    background-repeat: no-repeat;
    background-size: 15px;
    background-position: right bottom;
  }
}
.divRadioActive {
  border-color: #2062e7;
  color: #333333;
  font-weight: 400;
  background-image: url("../../../assets/images/backstage/蒙版组 66.png");
  background-repeat: no-repeat;
  background-size: 15px;
  background-position: right bottom;
}
.bottom {
  .bottombutton1 {
    width: 100px;
    height: 32px;
    background: #ffffff;
    border: 1px solid #ccc;
    opacity: 1;
    border-radius: 6px;
    font-weight: 400;
    line-height: 12px;
    color: #333333;
    &:hover {
      background: #f6f7fa;
      border: 1px solid #1f4287;
      color: #1f4287;
    }
  }
  .bottombutton2 {
    width: 100px;
    height: 32px;
    background: #1f4287;
    border: 1px solid #1f4287;
    opacity: 1;
    border-radius: 6px;
    font-weight: 400;
    line-height: 12px;
    color: #fff;
    &:hover {
      background: #1f4287;
      border: 1px solid #1f4287;
      color: #fff;
      opacity: 0.9;
    }
  }
}
.addDialog {
  & > div {
    margin-bottom: 20px;
  }
  .label {
    display: inline-block;
    height: 32px;
    width: 100px;
    line-height: 32px;
  }
  .formcnt {
    display: inline-block;
    .picker {
      width: 200px;
    }
    .formcntButton {
      width: 88px;
      height: 32px;
      background: #fff;
      border: 1px solid #1f4287;
      opacity: 1;
      border-radius: 6px;
      font-weight: 400;
      line-height: 12px;
      color: #1f4287;
      &:hover {
        background: #1f4287;
        border: 1px solid #1f4287;
        color: #fff;
      }
    }
  }
  .form-item {
    .deleteGoodsbutton {
      color: #1f4287;
      cursor: pointer;
    }
  }
  .my_select_time {
    position: relative;
    display: inline-block;

    .time_to_text {
      display: inline-block;
      font-size: 14px;
      padding: 0px !important;
      height: 32px;
      line-height: 32px;
      border-top: 1px solid #b7bcc6;
      color: #666666;
      margin-top: 0px !important;
      border-bottom: 1px solid #b7bcc6;
      vertical-align: bottom;
      text-align: center;
      width: 14px;
    }

    .to_text_disabled {
      background: #f5f7fa;
      cursor: not-allowed;
    }

    .time1 {
      width: 110px;
      /deep/.el-input__inner {
        padding: 0 0px 0 7px !important;
        border-right: 0px;
        border-radius: 6px;
        border-top-right-radius: 0px;
        border-bottom-right-radius: 0px;
      }
    }

    .time2 {
      width: 155px;
      /deep/.el-input__inner {
        border-left: 0px;
        border-radius: 6px;
        border-top-left-radius: 0px;
        border-bottom-left-radius: 0px;
        padding: 0 20px 0 4px !important;
      }
    }

    .date_icon2,
    .date_icon1 {
      position: absolute;
      right: 5px;
      height: 32px;
      line-height: 32px;
      width: 16px;
      font-size: 16px;
    }

    .date_icon1 {
      display: none;
      cursor: pointer;
    }
  }
  .my_select_time:hover {
    .date_icon2 {
      display: none;
    }

    .date_icon1 {
      display: inline-block;
    }
  }
}
.section-center-content-box {
  box-sizing: border-box;
  padding: 18px 30px 24px 30px;
  // margin-top: 10px;
  background: rgba(255, 255, 255, 1);
  // border: 1px solid rgba(230, 230, 230, 1);
  box-shadow: 0px 4px 12px rgba(221, 221, 221, 0.3);
  border-radius: 6px;
  // margin-top: 10px;
  .table-box {
    .editElembutton {
      margin-left: 32px;
      width: 28px;
      height: 20px;
      font-size: 14px;
      font-weight: 400;
      line-height: 21px;
      color: #1f4287;
      opacity: 1;
      cursor: pointer;
    }
    .deleteElembutton {
      margin-left: 20px;
      width: 28px;
      height: 20px;
      font-size: 14px;
      font-weight: 400;
      line-height: 21px;
      color: #1f4287;
      cursor: pointer;
      opacity: 1;
    }
  }
}
.bonushHeight {
  // margin-top: 10px;
  // margin-bottom: 20px;
  // height: 800px;
  .backCardList {
    width: 231px;
    height: 20px;
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
    color: rgba(153, 153, 153, 1);
    opacity: 1;
    margin-bottom: 40px;
    cursor: pointer;

    .verticalLine {
      width: 1px;
      height: 18px;
      background: #ffffff;
      opacity: 1;
      margin: 0 20px;
    }

    .membership {
      width: 90px;
      height: 25px;
      font-size: 18px;
      font-weight: bold;
      line-height: 21px;
      color: #333333;
      opacity: 1;
    }
  }
  .addbutton {
    //  width: 100px;
    margin-top: 26px;
    margin-bottom: 20px;
    height: 32px;
    background: #1f4287;
    border: 1px solid #1f4287;
    opacity: 1;
    border-radius: 6px;
    font-weight: 400;
    line-height: 12px;
    color: #fff;
    &:hover {
      background: #1f4287;
      border: 1px solid #1f4287;
      color: #fff;
      opacity: 0.9;
    }
  }
  .buildRules {
    width: 108px;
    height: 25px;
    font-size: 18px;

    font-weight: bold;
    line-height: 21px;
    color: rgba(51, 51, 51, 1);
    opacity: 1;
    margin-bottom: 45px;
  }
}
</style>
